import React from "react";
import ColumnItem from "../columns/ColumnItem";
import ColumnAccount from "../columns/ColumnAccount";
import ColumnQuantity from "../columns/ColumnQuantity";
import ColumnRate from "../columns/ColumnRate";
import ColumnDisc from "../columns/ColumnDisc";
import ColumnTax from "../columns/ColumnTax";
import ColumnAmount from "../columns/ColumnAmount";
import ColumnOther from "../columns/ColumnOther";
import ColumnOtherAmount from "../columns/ColumnOtherAmount";
import ColumnDescription from "../columns/ColumnDescription";
import ColumnRowIndex from "../columns/ColumnRowIndex";
import ColumnAvailable from "../columns/ColumnAvailable";
import ColumnImage from "../columns/ColumnImage";
import ColumnActions from "../columns/ColumnActions";
import NUMBER from "../components/NUMBER";
import ImgComponent from "../../ImgComponent/ImgComponent";
import { Grid, TextField } from "@mui/material";
import VarValue from "../../Accordian/VarValue";

export const createColumnRenderers = ({ rows = [], rowErrors = {} }) => ({
  col_row_index: ({ params }) => {
    const rowIndex = rows.findIndex((row) => row.id === params.row.id) + 1;
    return <ColumnRowIndex rowIndex={rowIndex} />;
  },
  col_item: ({ params, item, handleRowUpdate, colItemOptions, data, priceSelect }) => {
    const rowError = rowErrors[params?.row?.id]?.["col_item"];
    return (
      <ColumnItem
        params={params}
        item={item}
        handleRowUpdate={handleRowUpdate}
        colItemOptions={colItemOptions}
        data={data}
        priceSelect={priceSelect}
        rowError={rowError}
      />
    );
  },
  col_account: ({ params, item, handleRowUpdate, colAccountOptions, formAction, documentSelectTableData }) => {
    return (
      <ColumnAccount
        params={params}
        item={item}
        handleRowUpdate={handleRowUpdate}
        colAccountOptions={colAccountOptions}
        formAction={formAction}
        documentSelectTableData={documentSelectTableData}
      />
    );
  },
  col_qty: ({ params, item, quantitySelectOptions, handleRowUpdate, formAction, documentSelectTableData }) => {
    const rowError = rowErrors[params?.row?.id]?.["col_qty"];
    return (
      <ColumnQuantity
        params={params}
        item={item}
        quantitySelectOptions={quantitySelectOptions[params?.row?.col_item]}
        handleRowUpdate={handleRowUpdate}
        formAction={formAction}
        documentSelectTableData={documentSelectTableData}
        rowError={rowError}
      />
    );
  },
  col_rate: ({ params, item, handleRowUpdate, disableRate }) => {
    const rowError = rowErrors[params?.row?.id]?.[item?.sColumnID || "col_rate"];
    return (
      <ColumnRate
        params={params}
        item={item}
        handleRowUpdate={handleRowUpdate}
        disableRate={disableRate}
        rowError={rowError}
      />
    );
  },
  col_disc: ({ params, item, handleRowUpdate, formAction, documentSelectTableData }) => {
    const rowError = rowErrors[params?.row?.id]?.[item?.sColumnID || "col_disc"];
    return (
      <ColumnDisc
        params={params}
        item={item}
        handleRowUpdate={handleRowUpdate}
        formAction={formAction}
        documentSelectTableData={documentSelectTableData}
        rowError={rowError}
      />
    );
  },
  col_tax: ({ params, item, handleRowUpdate, colTaxOptions, formAction, documentSelectTableData }) => {
    return (
      <ColumnTax
        params={params}
        item={item}
        handleRowUpdate={handleRowUpdate}
        colTaxOptions={colTaxOptions}
        formAction={formAction}
        documentSelectTableData={documentSelectTableData}
      />
    );
  },
  col_dExpectedQuantity: ({ params, item, quantitySelectOptions }) => {
    const colId = item?.inputtable?.sColumnID || item?.sColumnID;
    const value = params?.row?.[colId] ?? "0";
    const fieldId = params?.row?._fieldIds?.[colId] || item?.component?.sName || colId;
    const options = quantitySelectOptions?.[params?.row?.col_item] || [];
    const selectValue = params?.row?.col_sExpectedType ?? params?.row?.col_qty_select ?? "";
    const selectedOption = options?.find(opt => opt?.sRelativeUnitCode === selectValue);
    const unitLabel = selectedOption?.sUnitAbbrev || "";
    return (
      <section style={{ display: "flex", flexDirection: "column", gap: 0 }}>
        <div style={{ display: "flex" }}>
          <TextField
            type="text"
            disabled
            id={`${fieldId}-${params?.row?.id}`}
            value={value}
            sx={{ "& input": { textAlign: "right" } }}
          />
          <TextField
            type="text"
            disabled
            value={unitLabel}
            sx={{ maxWidth: 80 }}
          />
        </div>
      </section>
    );
  },
  col_amount: ({ params, item }) => {
    return <ColumnAmount params={params} item={item} />;
  },
  col_other: () => <ColumnOther />,
  col_otheramount: () => <ColumnOtherAmount />,
  col_description: () => <ColumnDescription />,
  col_available: ({ item, params, defaultTableSelectedLocation }) => 
    <Grid item {...item?.grid_props}>
      <VarValue data={item} textValue={{...params?.row, sLocationCode: defaultTableSelectedLocation}} />
    </Grid>,
  col_img: ({ item, params }) => 
    <ImgComponent
      value={params?.row?.[item?.inputtable?.sColumnID]} 
      data={item} 
      id={params?.row?.id} 
    />,
  col_actions: ({ params, data, handleDeleteRow, handleAddRowAtIndex, handleRowClone }) => {
    return <ColumnActions 
        params={params} 
        data={data}
        handleDeleteRow={handleDeleteRow}
        handleAddRowAtIndex={handleAddRowAtIndex}
        handleRowClone={handleRowClone}
      />
  },
});

export const createSummaryRenderers = ({ componentType }) => {
  switch(componentType) {
    case "NUMBER": <NUMBER />
      break;
  }
}
